import './ApplyFormNew.scss'

import * as React from 'react'

import Layout from '../Layout/Layout'
import ContactForm from './ContactForm'
import { submitForm } from './ApplyFormServices'

import ContactFormImage from '../../images/contact_form.png'
import Logo from '../../images/logo-purple.svg'
import LogoDark from '../../images/logo-dark.svg'


declare var amplitude: any

export class ApplyForm extends React.PureComponent {
  handleSubmit = async (values: any, { setSubmitting, setStatus, resetForm, setFieldError }: any) => {
    try {
      try {
        let identify = new amplitude.Identify().set('email', values.email);
        amplitude.getInstance().identify(identify);
      } catch (err) {
        console.log(err);
      }

      await submitForm(values, setSubmitting, setStatus)

      resetForm()
    } catch (err) {
      if (err && err.email) {
        setFieldError('email', err.email)
      }
    }
  }

  render() {
    return (
      <Layout footer={false}>
        <div className='apply-page'>
          <aside className='apply-page__aside'>
            <nav>
              <a href='https://letsenhance.io' target="_blank">
                <img
                  className="aside__logo"
                  src={Logo}
                />
              </a>
            </nav>

            <div className='aside__content'>

              <h1 className='aside__title'>
                Let us enhance your images
              </h1>

              <div>
                <p className='aside__text'>
                  For the last 2 years, our team researched most image enhancement approaches and problems.
                  <br/>
                  <br/>
                  We automatically prepare visuals for website requirements, e-commerce, printing, or any personal use.
                  <br/>
                  You can find the autogenerated API key in <a className="aside__link" href="https://letsenhance.io/v2/account/api">My account</a> section on the website - up to 5k image batches.
                  <br/>If you need a larger amount or having a specific case, please fill the form and we will contact you shortly.
                </p>
              </div>

              <div className='aside__illustration'>
                <img
                  className='aside__illustration__image'
                  src={ContactFormImage}
                  alt="Let's Enhance image"
                />
              </div>

              <div className='aside__contact'>
                Write us at <span className='aside__contact-link'>b2b-inquiries@letsenhance.io</span>
              </div>
            </div>

          </aside>
          <section className='apply-page__contact-form'>

            <nav>
              <a href='https://letsenhance.io' target="_blank">
                <img
                  className="contact-form__logo"
                  src={LogoDark}
                />
              </a>
            </nav>

            <div className='contact-form__content'>
              <h1 className='contact-form__title'>
                Let us enhance your images
              </h1>
              <ContactForm onSubmit={this.handleSubmit} />
              <div className='contact-form__separator'>or</div>
              <div className='contact-form__contact'>
                Write us at <a className='contact-form__contact-link' href='mailto:b2b-inquiries@letsenhance.io'>
                  b2b-inquiries@letsenhance.io
                </a>
              </div>
            </div>
          </section>
        </div>
      </Layout>
    )
  }
}


